import React, { createContext, useContext, useEffect, useState } from "react";
import { sendWaiter, sendBill } from "./assets/BotRequest";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import {
  getLongLanguageName,
  handleButtonSpecificLogic,
  getUmbrellaMessage
} from "./assets/hooks/functions";
import rest from "./RESTDATA";
import useGeo from "./assets/hooks/useGeo";
import useUserIp from "./assets/hooks/useUserIp";
import useHighSeason from "./assets/hooks/useHighSeason";
import { handleSendTech } from "./assets/actionsTech";

const MyContext = createContext();

export function useMyContext() {
  return useContext(MyContext);
}

export const MyContextProvider = ({ children }) => {
  //check is now is high season between 1/04 and 30/10
  const isHighSeason = useHighSeason();
  const countTimer = 60;
  const [zonti, setZont] = useState(null);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const [showTableHeader, setShowTableHeader] = useState(false);

  const [countdownWaiter, setCountdownWaiter] = useState(0);
  const [countdownBill, setCountdownBill] = useState(0);
  // Function to introduce a delay for proper upload of Geolocation
  const ms = 1600;
  const delay = () => new Promise((resolve) => setTimeout(resolve, ms));

  const [isWaiterButtonActive, setWaiterButtonActive] = useState(true);
  const [isButtonBillActive, setButtonBillActive] = useState(true);

  const [showInside, setShowInside] = useState(false);
  const [showScan, setShowScan] = useState(false);
  //onlyMenu=1 means full menu
  //onlyMenu=2 means beach menu
  //onlyMenu=null means full menu but without scrolling to it
  const [onlyMenuFromParams, setOnlyMenu] = useState(null);
  // useEffect(() => {
  //   // eslint-disable-next-line
  //   if (onlyMenuFromParams == 1) {
  //     handleSendTech(1);
  //   }
  //   // eslint-disable-next-line
  //   if (onlyMenuFromParams == 2) {
  //     handleSendTech(2);
  //   }
  // },[onlyMenuFromParams]);
  const { i18n, t } = useTranslation();
  const [lang, setLang] = useState(i18n.language);
  const language = getLongLanguageName(lang);
  const messageRun = t("alert.run");
  const messageOops = t("alert.oops");
  const messageGot = t("alert.got");
  const messageInside = t("alert.inside");
  const messageElse = t("alert.else");
  const messageEnable = t("alert.enableLoc");
  const {
    isGeolocationAvailable,
    currentPosition,
    updateGeolocation,
    radius,
    setRadius,
    // isInRest,
  } = useGeo(zonti, isHighSeason);
  // const { userIp, error } = useUserIp();

  const messageWaiter1 = `${rest.name}.Table ${getUmbrellaMessage(zonti)} called the Waiter.  Language - ${language}.\nΤραπέζι ${getUmbrellaMessage(zonti)} κάλεσε τον σερβιτόρο. Γλώσσα - ${language}.`;
  let messageBill1 = `${rest.name}. Table ${getUmbrellaMessage(zonti)} asks for Bill. Language - ${language}.\nΤραπέζι ${getUmbrellaMessage(zonti)} ζητά τον λογαριασμό.  Γλώσσα - ${language}. `;

  const [modalVisible, setModalVisible] = useState(false);
  const [loadingModal, setLoading] = useState(true);
  const [modalContent, setModalContent] = useState("");
  const [run, setRun] = useState(false);
  const showModal = (
    content = "sending your message...",
    loading = true,
    run = false
  ) => {
    setModalVisible(true);
    setModalContent(content);
    if (loading) {
      setLoading(true);
    } else setLoading(false);
    if (run) {
      setRun(true);
    }
  };

  const hideModal = () => {
    setLoading(false);
    setModalVisible(false);
  };

  const confirmAction = (message) => {
    const confirmed = window.confirm(message);
    if (confirmed) {
      return true;
    }
    return false;
  };

  const performActionBill = async (action) => {
    try {
      handleButtonSpecificLogic(
        setButtonBillActive,
        setCountdownBill,
        countTimer,
        "Bill"
      );
      await action();
      hideModal();
      showModal();
    } catch (error) {
      alert(
        `${messageOops}.Error in performActionBill: ${JSON.stringify(error)}`
      );
    }
  };
  const performActionWaiter = async (action) => {
    try {
      handleButtonSpecificLogic(
        setWaiterButtonActive,
        setCountdownWaiter,
        countTimer,
        "Waiter"
      );
      await action();
      hideModal();
      showModal();
    } catch (error) {
      showModal(
        `${messageOops}.Error in performActionWaiter: ${JSON.stringify(error)}`,
        false,
        true
      );
    }
  };
  const handleCallWaiter = async () => {
    if (!isGeolocationAvailable) {
      updateGeolocation();
      await delay();
    }

    if (isGeolocationAvailable) {
      if (isWaiterButtonActive) {
        if (!isButtonBillActive && !confirmAction(messageElse)) {
          return;
        }
        if (
          currentPosition.distanceToRest <=
          Number(radius) + currentPosition.accuracy
        ) {
          performActionWaiter(() => {
            sendWaiter(
              messageWaiter1,
              getUmbrellaMessage(zonti),
              rest.backendEndpoints.waiter,
              rest.chat_id,
              showModal,
              messageGot,
              (responseData) => {
                // Success callback
                hideModal();
                console.log("SUCCESSS", responseData);
                showModal(messageGot, false, true);
                setShowTableHeader(false);
                setShowInside(false);
                setShowScan(true);
              },
              (error) => {
                // Error callback
                console.error(error);
                showModal(messageOops);
                setShowTableHeader(false);
                setShowInside(false);
                setShowScan(true);
              }
            );
          });
        } else {
          updateGeolocation();
          showModal(`${messageInside}`, false, false);
          setTimeout(function () {
            hideModal(); // Call hideModal function after 10 seconds
          }, 30000);
          history?.replaceState({}, document.title, window?.location.pathname);

          setShowTableHeader(false);
          setShowScan(false);
          setShowInside(true);
        }
      } else {
        showModal(messageRun, false, true);
        setTimeout(function () {
          hideModal(); // Call hideModal function after 10 seconds
        }, 10000); // 10 seconds in milliseconds
      }
    } else {
      updateGeolocation();
      // Handle case where geolocation was rejected
      showModal(messageEnable, false, false);
    }
  };

  const handleCallBill = async () => {
    await delay();
    if (isGeolocationAvailable) {
      if (isButtonBillActive) {
        if (!isWaiterButtonActive) {
          showModal(messageRun, false, true);
          return;
        }

        if (
          currentPosition.distanceToRest <=
          Number(radius) + currentPosition.accuracy
        ) {
          const paymentWithCash = window.confirm(t("bill.payment"));
          // Determine the payment method based on the user's choice
          const paymentMethod = paymentWithCash ? "Cash" : "Card";
          // Include the payment method in the message
          messageBill1 = `${rest.name}.Table ${getUmbrellaMessage(zonti)} asks for Bill. Payment Method: ${paymentMethod}. Language - ${language}.\nΤραπέζι ${getUmbrellaMessage(zonti)} ζητά τον λογαριασμό. Τρόπος Πληρωμής:${paymentMethod}. Γλώσσα - ${language}.`;
          performActionBill(() => {
            sendBill(
              messageBill1,
              getUmbrellaMessage(zonti),
              rest.backendEndpoints.waiter,
              rest.chat_id,
              (responseData) => {
                // Success callback
                showModal(messageGot, false, true);
                setShowTableHeader(false);
                setShowScan(true);
              },
              (error) => {
                // Error callback
                showModal(messageOops);
                setShowTableHeader(false);
                setShowScan(true);
              }
            );
          });
        } else {
          updateGeolocation();
          showModal(`${messageInside}`, false, false);
          history?.replaceState({}, document.title, window.location.pathname);
          // router?.replace(router?.asPath, undefined, { shallow: true });
          setShowTableHeader(false);
          setShowScan(false);
          setShowInside(true);
        }
      } else {
        showModal(messageRun, false, true);
        setTimeout(function () {
          hideModal(); // Call hideModal function after 10 seconds
        }, 10000);
        setShowTableHeader(false);
        setShowScan(false);
        setShowInside(true);
      }
    } else {
      updateGeolocation();
      // Handle case where geolocation was rejected
      showModal(messageEnable, false, false);
    }
  };
  // Periodically update the Waiter countdown timer using setInterval
  // useEffect(() => {
  //   const waiterInterval = setInterval(() => {
  //     // Update countdown of Waiter button
  //     setCountdownWaiter((prevCountdown) => {
  //       if (prevCountdown === 0) {
  //         // Countdown finished
  //         clearInterval(waiterInterval); // Stop the interval
  //         setWaiterButtonActive(true);
  //         return 0;
  //       } else {
  //         return prevCountdown - 1;
  //       }
  //     });
  //   }, 1000); // 1 second interval

  //   return () => clearInterval(waiterInterval); // Cleanup when the component unmounts
  // }, [isWaiterButtonActive]);
  // Periodically update the Bill countdown timer using setInterval
  // useEffect(() => {
  //   const billInterval = setInterval(() => {
  //     // Update countdown of Waiter button
  //     setCountdownBill((prevCountdown) => {
  //       if (prevCountdown === 0) {
  //         // Countdown finished
  //         clearInterval(billInterval); // Stop the interval
  //         setButtonBillActive(true);
  //         return 0;
  //       } else {
  //         return prevCountdown - 1;
  //       }
  //     });
  //   }, 1000); // 1 second interval

  //   return () => clearInterval(billInterval); // Cleanup when the component unmounts
  // }, [isButtonBillActive]);

  // Load countdown start time and button state from localStorage on component mount
  useEffect(() => {
    const savedStartTimeWaiter = parseInt(
      localStorage.getItem("StartTimeWaiter"),
      10
    );
    const savedIsWaiterButtonActive = JSON.parse(
      localStorage.getItem("isWaiterButtonActive")
    );

    if (!isNaN(savedStartTimeWaiter) && savedIsWaiterButtonActive !== null) {
      const currentTime = Math.floor(new Date().getTime() / 1000);
      const elapsedSeconds = currentTime - savedStartTimeWaiter;

      if (elapsedSeconds >= countTimer) {
        // Timer has expired, set button as active
        setWaiterButtonActive(true);
        setCountdownWaiter(0);
        localStorage.removeItem("StartTimeWaiter");
      } else {
        // Timer still active, set button as inactive
        setWaiterButtonActive(false);
        setCountdownWaiter(countTimer - elapsedSeconds);
      }
    }
  }, []);
  useEffect(() => {
    const savedStartTimeBill = parseInt(
      localStorage.getItem("StartTimeBill"),
      10
    );
    const savedButtonBillActive = JSON.parse(
      localStorage.getItem("isButtonBillActive")
    );

    if (!isNaN(savedStartTimeBill) && savedButtonBillActive !== null) {
      const currentTime = Math.floor(new Date().getTime() / 1000);
      const elapsedSeconds = currentTime - savedStartTimeBill;

      if (elapsedSeconds >= countTimer) {
        // Timer has expired, set button as active
        setButtonBillActive(true);
        setCountdownBill(0);
        localStorage.removeItem("StartTimeBill");
      } else {
        // Timer still active, set button as inactive
        setButtonBillActive(false);
        setCountdownBill(countTimer - elapsedSeconds);
      }
    }
  }, []);

  useEffect(() => {
    if (zonti) {
      setShowTableHeader(true);
      setOnlyMenu(2);
    } else {
      setShowTableHeader(false);
    }
  }, [zonti]);

  const contextValue = {
    countdownWaiter,
    countdownBill,
    isWaiterButtonActive,
    isButtonBillActive,
    setCountdownWaiter,
    setButtonBillActive,
    handleCallWaiter,
    handleCallBill,
    zonti,
    setZont,
    rest,
    lang,
    setLang,
    isSmallScreen,
    showTableHeader,
    setRadius,
    radius,
    currentPosition,
    modalVisible,
    loadingModal,
    modalContent,
    hideModal,
    run,
    showInside,
    showScan,
    messageInside,
    setOnlyMenu,
    onlyMenuFromParams,
  };

  return (
    <MyContext.Provider value={contextValue}>{children}</MyContext.Provider>
  );
};
